import { DART_GAME, TRAJECTORY_CONFIG } from '../constants';

export const computeTrajectoryPoints = (vector, origin, floorY, boundsWidth) => {
  if (!vector || !origin) return [];
  
  const distance = Math.hypot(vector.x, vector.y);
  if (distance < DART_GAME.MIN_AIM_DISTANCE) return [];
  
  const ratio = Math.min(distance, DART_GAME.MAX_PULL) / distance;
  const limitedVector = {
    x: vector.x * ratio,
    y: vector.y * ratio,
  };
  
  const velocity = {
    vx: -limitedVector.x * DART_GAME.POWER_SCALE,
    vy: -limitedVector.y * DART_GAME.POWER_SCALE,
  };
  
  const points = [];
  const { STEPS, STEP_TIME } = TRAJECTORY_CONFIG;

  for (let i = 1; i <= STEPS; i++) {
    const t = STEP_TIME * i;
    const x = origin.x + velocity.vx * t;
    const y = origin.y + velocity.vy * t + 0.5 * DART_GAME.GRAVITY * (t ** 2);
    
    if (x < DART_GAME.DART_SIZE || x > boundsWidth - DART_GAME.DART_SIZE) break;
    if (y > floorY() + DART_GAME.DART_SIZE) break;
    
    points.push({
      x,
      y,
      opacity: Math.max(0, 1 - i / (STEPS + 2)),
    });
  }

  return points;
};

export const calculateVelocity = (dragVector) => {
  const distance = Math.hypot(dragVector.x, dragVector.y);
  const ratio = Math.min(distance, DART_GAME.MAX_PULL) / distance;
  const limitedVector = {
    x: dragVector.x * ratio,
    y: dragVector.y * ratio,
  };

  return {
    vx: -limitedVector.x * DART_GAME.POWER_SCALE,
    vy: -limitedVector.y * DART_GAME.POWER_SCALE,
  };
};

export const checkBoundsCollision = (position, bounds, floorY) => {
  if (position.x < DART_GAME.DART_SIZE || position.x > bounds.width - DART_GAME.DART_SIZE) {
    return 'wall';
  }
  if (position.y < DART_GAME.DART_SIZE) {
    return 'ceiling';
  }
  if (position.y >= floorY()) {
    return 'ground';
  }
  return null;
};

